import React from 'react'
import { Box, Combobox, Input, type ComboboxProps } from '@node-space/ui-components'
import { AddCustomerActions } from 'pages/EmbeddedCustomers/AddCustomer/AddCustomerActions'
import type { CreateCustomerAgreement } from 'types/customers'
import { useAddCustomerAgreementForm } from '../hooks/useAddCustomerAgreementForm'

export interface AddCustomerAgreementFormProps {
  defaultValues?: CreateCustomerAgreement
  onConfirm: (
    data: CreateCustomerAgreement,
    displayData: Partial<Record<keyof CreateCustomerAgreement, string>>
  ) => void
  onCancel: () => void
}

export const AddCustomerAgreementForm = ({
  defaultValues,
  onConfirm,
  onCancel,
}: AddCustomerAgreementFormProps) => {
  const {
    formValues,
    hasErrors,
    handleSubmit,
    setInputField,
    setComboboxField,
    useCaseOptions,
    countryOptions,
    isFetchingCountries,
    buildDisplayData,
  } = useAddCustomerAgreementForm(defaultValues)

  const onSubmit = (data: CreateCustomerAgreement) => {
    onConfirm(data, buildDisplayData(data))
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box flexCol gap={16}>
        <Input {...setInputField({ key: 'customerName' })} testId="agreement-customer-name" />
        <Input {...setInputField({ key: 'reference' })} testId="agreement-reference" />
        <Combobox
          {...(setComboboxField({ key: 'useCase', items: useCaseOptions }) as ComboboxProps)}
          defaultValue={formValues.useCase}
          testId="agreement-use-case"
        />
        <Combobox
          {...(setComboboxField({ key: 'countryCode', items: countryOptions }) as ComboboxProps)}
          defaultValue={formValues.countryCode}
          loadingInline={isFetchingCountries}
          testId="agreement-country-code"
        />
      </Box>
      <AddCustomerActions onCancel={onCancel} isDisableContinue={hasErrors} />
    </form>
  )
}
